// Styles
import styles from './index.module.scss';

// Components
import { BaseImage } from 'components';

// Interfaces
import { IBaseUploaderInlineProps } from './interfaces';

// Antd
import { Typography, Popconfirm } from 'antd';
import { SyncOutlined } from '@ant-design/icons';

// Mobx
import { observer } from 'mobx-react';

// i18n
import { useTranslation } from 'react-i18next';

// Custom Hooks
import { useUploader } from 'hooks';

// Constant
import { ALL_FILE_EXTENSIONS } from 'constant/file.constant';

// DOC, DOCX, PDF, PPT, XLS, XLSX : variables above before fixing

const BaseUploaderInline = observer(
  ({ children, originalFileName, onDelete, onUpload, onDownload, loading, isReadOnly, noDelete }: IBaseUploaderInlineProps) => {
    // Hook
    const { t } = useTranslation();
    const { uploader_Input, uploader_onClickSingleFile } = useUploader({
      acceptedExtensions: ALL_FILE_EXTENSIONS,
    });

    return (
      <>
        {/* Plain HTML Input File */}
        {onUpload && uploader_Input(onUpload)}
        <div className={styles['wrapper']}>
          {/* Uploader */}
          <div className={styles['inline-uploader']}>
            <div className={styles['label']} style={{ width: !isReadOnly ? 350 : 400 }}>
              {!originalFileName ? (
                <div className={styles['placeholder']}>{isReadOnly ? '' : t('shared.certificateForm.action.uploadDocument')}</div>
              ) : (
                <Typography.Text
                  ellipsis={{ tooltip: originalFileName }}
                  onClick={() => onDownload && onDownload()}
                  style={{ color: '#0e38b7', fontSize: 14, cursor: 'pointer' }}
                >
                  {originalFileName}
                </Typography.Text>
              )}
            </div>

            {/* Check if not readonly */}
            {!isReadOnly && (
              <div className={styles['action']}>
                {loading ? (
                  <div className={`${styles['picker']} ${styles['no-pointer']}`}>
                    <SyncOutlined spin />
                  </div>
                ) : (
                  <>
                    {/* Close Icon */}
                    {originalFileName && !noDelete && (
                      <Popconfirm title={`${t('app.action.delete')}?`} onConfirm={onDelete}>
                        <div className={styles['close']}>
                          <BaseImage isIcon icon="close" width="15px" height="15px" />
                        </div>
                      </Popconfirm>
                    )}

                    {/* Folder Icon */}
                    <div className={styles['picker']} onClick={uploader_onClickSingleFile}>
                      <BaseImage isIcon icon="folder" width="16.13px" height="14.27px" />
                    </div>
                  </>
                )}
              </div>
            )}

            {/* Check if readonly and render the loading */}
            {isReadOnly && loading && (
              <div className="pr-2">
                <SyncOutlined spin />
              </div>
            )}
          </div>

          {/* Children */}
          {children && children}
        </div>
      </>
    );
  },
);

export { BaseUploaderInline };
